import { l } from '@manychat/manyui'

import WaIllustrationPaywall from 'apps/whatsApp/assets/WaIllustrationPaywall.png'
import { billing } from 'common/billing'

export const WhatsAppPaywall = billing.paywalls.universal({
  preheading: l.makeTranslate('Try {planTitle} for free'),
  title: l.makeTranslate(
    'Go {planTitle} to start conversations that <span style="color:#007839;">actually convert</span>',
  ),
  text: l.makeTranslate(
    `Ready to see your engagement sky rocket and turn conversations into cash? 🤑 Go {planTitle} to send personalized messages and WhatsApp Broadcasts from one of the world’s most trusted platforms.
    <br/><br/>
    Try it for free and <span style="color:#007839;">cancel anytime</span> if you're not feeling it.`,
  ),
  image: { src: WaIllustrationPaywall, style: { padding: 0, borderRadius: 0 } },
  benefits: {
    title: l.makeTranslate('WhatsApp and {planTitle} do more than you think:'),
    items: [
      l.makeTranslate('Schedule promos to reach your audience at scale'),
      l.makeTranslate('Automate simple and complex conversational logics'),
      l.makeTranslate('Get more customers with Ads that click to WhatsApp'),
    ],
  },
})
